<form [formGroup]="sendForwardForm()">
  <div class="flex flex-col gap-lg">
    <div
      class="grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))] gap-lg">
      <div>
        <lib-paginated-select
          [inputFormControlName]="'reason_option_id'"
          [id]="'reason_option_id'"
          [name]="'reason_option_id'"
          [label]="'request_screen_reason_label' | transloco"
          [placeholder]="'request_screen_select_reason_placeholder' | transloco"
          [apiUrl]="
            baseUrl +
            '/lookup/variable-options?filters[variable][module]=workflow&filters[variable][key]=action_reason&filters[is_active]=1'
          "
          [required]="true"
          [filters]="[]"
          [detailsNotFoundLabel]="'details_not_found_label' | transloco"
          [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />

        <lib-validation-message
          [lang]="'current_lang' | transloco"
          control="reason_option_id" />
      </div>
    </div>

    <div class="gap-lg w-full">
      <div>
        <lib-rich-editor-dual-lang-text-area
          [inputFormControlName]="'comment'"
          [id]="'comment'"
          [name]="'comment'"
          [label]="'request_screen_send_forward_comment_label' | transloco"
          [placeholderEn]="
            'request_screen_send_forward_comment_placeholder' | transloco
          "
          [placeholderAr]="
            'request_screen_send_forward_comment_placeholder' | transloco
          "
          [width]="'100%'"
          [requiredEn]="true"
          [requiredAr]="false"
          [disabled]="false"
          [canResize]="false"
          [isSingleInput]="true" />
      </div>
    </div>

    <div class="flex justify-end gap-md mt-lg">
      <button
        type="button"
        (click)="onClose()"
        class="px-lg py-sm rounded-md text-neutral-600 bg-white border border-neutral-300 text-sm font-medium cursor-pointer">
        {{ 'request_screen_cancel_button' | transloco }}
      </button>
      <button
        type="button"
        (click)="onSubmit()"
        [disabled]="sendForwardForm().invalid"
        class="px-lg py-sm rounded-md text-white bg-primary-500 text-sm font-medium border-none cursor-pointer"
        [class.opacity-30]="sendForwardForm().invalid">
        {{ 'request_screen_submit_button' | transloco }}
      </button>
    </div>
  </div>
</form>
